module.exports = __webpack_public_path__ + "static/media/2_Dias_y_horas-min.b5b20487.jpg";